import { Env, readFromEnv } from '@cinch-nx/environments'
import axios from 'axios'

export const fulfilmentClient = axios.create({
  baseURL: readFromEnv(Env.LogisticsFulfilmentServiceUrl),
  headers: {
    'x-api-key': readFromEnv(Env.LogisticsFulfilmentServiceApiKey),
  },
})
